/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLoginIcon16Light = forwardRef('ArrowUiAuthLoginIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.5 2A1.5 1.5 0 0 1 13 3.5v8a1.5 1.5 0 0 1-1.5 1.5h-5a.5.5 0 0 0 0 1h5a2.5 2.5 0 0 0 2.5-2.5v-8A2.5 2.5 0 0 0 11.5 1h-5a.5.5 0 0 0 0 1h5Z" }),
        React.createElement("path", { d: "M6.127 4.164a.5.5 0 0 0 .035.707L8.515 7H1.5a.5.5 0 0 0 0 1h7.015l-2.353 2.13a.5.5 0 1 0 .672.74l2.7-2.443a1.25 1.25 0 0 0 0-1.854l-2.7-2.444a.5.5 0 0 0-.707.035Z" })));
});
